import { Badge, ContextBarItem, DROP_MENU_SELECTION_MODE, DropMenu, DropMenuItem } from '@sailadv/hdata-ui';
import { useTranslation } from 'react-i18next';

import { PRODUCT_OPTIONS } from '../../model/constants/product.constant';

export const ProductSwitcher = () => {
	const { t } = useTranslation('common');
	const { t: tLogin } = useTranslation('login');

	const [currentProduct] = PRODUCT_OPTIONS;

	return (
		<ContextBarItem
			icon={<currentProduct.Icon />}
			menu={
				<DropMenu
					aria-label={t('contextBar.product.title')}
					selectionMode={DROP_MENU_SELECTION_MODE.SINGLE}
					selectedKeys={[currentProduct.label]}
				>
					{PRODUCT_OPTIONS.map(({ label, Icon, disabled }) => (
						<DropMenuItem
							key={label}
							id={label}
							leading={<Icon />}
							disabled={disabled}
							trailing={disabled && <Badge tone="neutral">{tLogin('selectDomain.comingSoon')}</Badge>}
						>
							{label}
						</DropMenuItem>
					))}
				</DropMenu>
			}
		>
			{currentProduct.label}
		</ContextBarItem>
	);
};
